import './QuickAccessViewButton.scss';
import { AppSwitherIcon, StackIcon } from '@ui/icons';
import { AuditOutlined, TagOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { ComplianceCategory } from '@sonar-software/sonar-core';
import { getSonarObjectTypeFromId, getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';
import React, { useMemo } from 'react';
import { useApplicationReference, useCustomViews, useTagReference } from '@hooks';
const getViewType = (view, tag, app) => {
    var _a;
    switch (true) {
        case Boolean(view === null || view === void 0 ? void 0 : view.sonarObjectId):
            return React.createElement(React.Fragment, null,
                React.createElement(StackIcon, null),
                " ", view === null || view === void 0 ? void 0 :
                view.sonarObjectName);
        case Boolean(view === null || view === void 0 ? void 0 : view.sonarObjectTypeId):
            const sonarObjectType = (view === null || view === void 0 ? void 0 : view.sonarObjectTypeId) ? getSonarObjectTypeFromId(view === null || view === void 0 ? void 0 : view.sonarObjectTypeId) : undefined;
            return React.createElement(React.Fragment, null,
                React.createElement(UnorderedListOutlined, null),
                " ",
                getSonarObjectTypeLabel(sonarObjectType));
        case Boolean(view === null || view === void 0 ? void 0 : view.tagId):
            return React.createElement(React.Fragment, null,
                React.createElement(TagOutlined, null),
                " ", tag === null || tag === void 0 ? void 0 :
                tag.name);
        case Boolean(view === null || view === void 0 ? void 0 : view.applicationId):
            return React.createElement(React.Fragment, null,
                React.createElement(AppSwitherIcon, null),
                " ", app === null || app === void 0 ? void 0 :
                app.name);
        case Number.isInteger(view === null || view === void 0 ? void 0 : view.complianceCategory):
            return React.createElement(React.Fragment, null,
                React.createElement(AuditOutlined, null),
                " ",
                ComplianceCategory[(_a = view === null || view === void 0 ? void 0 : view.complianceCategory) !== null && _a !== void 0 ? _a : 0]);
        default:
            return null;
    }
};
export const QuickAccessViewButton = ({ viewId }) => {
    var _a, _b;
    const views = useCustomViews();
    const view = useMemo(() => views.find((found) => found.id === viewId), [views, viewId]);
    const tag = useTagReference((_a = view === null || view === void 0 ? void 0 : view.tagId) !== null && _a !== void 0 ? _a : -1);
    const app = useApplicationReference((_b = view === null || view === void 0 ? void 0 : view.applicationId) !== null && _b !== void 0 ? _b : -1);
    const viewType = useMemo(() => getViewType(view, tag, app), [view, tag, app]);
    return (React.createElement("div", { className: 'quick-access-view-button' },
        React.createElement("div", { className: 'view-name' }, view === null || view === void 0 ? void 0 : view.name),
        React.createElement("div", { className: 'view-type' }, viewType)));
};
